<template>
    <div id="secure">
        <h1>Secure Area</h1>
        <p>
            Đây là trang Secure sau khi login
        </p>
    </div>
</template>
<script>
export default {
  name: 'Secure',
  data () {
    return {}
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Secure.vue